export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المستلم:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لم يتم العثور على المستخدم"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["جهات الاتصال"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التفاصيل"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختيار المستخدمين"])}
}